import { Paperclip, Trash2 } from 'lucide-react';
import { toast } from 'sonner';

const MAX_FILE_SIZE = 10 * 1024 * 1024;

export function PendingFilesList({ pendingFiles, onRemovePending }) {
  if (pendingFiles.length === 0) return null;
  return (
    <div className="space-y-1 mt-1">
      {pendingFiles.map((f, idx) => (
        <div key={idx} className="flex items-center justify-between bg-[#FFF9E6] rounded px-2 py-1.5" data-testid={`pending-file-${idx}`}>
          <div className="flex items-center gap-1.5 text-sm text-[#111111] truncate">
            <Paperclip size={13} />
            <span className="truncate">{f.name}</span>
            <span className="text-xs text-[#999999]">({(f.size / 1024).toFixed(0)} KB)</span>
          </div>
          <button onClick={() => onRemovePending(idx)} className="text-[#999999] hover:text-[#DC2626]" data-testid={`remove-pending-${idx}`}>
            <Trash2 size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}

export function validateFiles(files, onValid) {
  if (!files || files.length === 0) return;
  const valid = [];
  Array.from(files).forEach(f => {
    if (f.size > MAX_FILE_SIZE) {
      toast.error(`${f.name} — файл слишком большой (макс 10MB)`);
      return;
    }
    valid.push(f);
  });
  if (valid.length) onValid(valid);
}

const MAX_MEDIA_SIZE = 50 * 1024 * 1024;

export function validateMediaFiles(files, onValid) {
  if (!files || files.length === 0) return;
  const valid = [];
  Array.from(files).forEach(f => {
    const isMedia = f.type.startsWith('image/') || f.type.startsWith('video/');
    if (!isMedia) {
      toast.error(`${f.name} — только фото или видео`);
      return;
    }
    if (f.size > MAX_MEDIA_SIZE) {
      toast.error(`${f.name} — файл слишком большой (макс 50MB)`);
      return;
    }
    valid.push(f);
  });
  if (valid.length) onValid(valid);
}
